import { CouponInfoModleItemType, CouponInfoModleListType } from './types'

function getDivValue(len: number) {
  if (len === 4) {
    return 2
  }
  return 3
}

/**
 * 目前卖家券： 2 - 6条数据；
 */
export function formatSellData(data: CouponInfoModleItemType[]): CouponInfoModleListType[] {
  const len = data.length
  const divValue = getDivValue(len)
  const arr: CouponInfoModleListType[] = []
  for (let i = 0; i < len; i += divValue) {
    const subArr = data.slice(i, i + divValue)
    arr.push(subArr)
  }
  return arr
}
